export default {
  user: {},

  allEmployee: [],

  employeeProfile: [],

  getAllRoles: [],

  employeeAccreditation: [],

  employeeApprovers: [],

  employeeAssociation: [],

  employeeBenefits: [],

  employeeBankInformation: [],

  employeeClaimsLimit: [],

  employeeContactReferences: [],

  employeeEducation: [],

  employeeFamilyInformation: [],

  employeeInformation: [],

  employeeIdentification: [],

  employeeJobHistory: [],

  employeeLeaveBalance: [],

  employeeLeaveBenefits: [],

  employeeMedical: [],

  employeePerformance: [],

  employeeSalaryInformation: [],

  employeeSalary: [],

  employeeTraining: [],

  employeeViolation: [],

  getAllEmployeeSchedule: [],

  scheduleToday: {},

  prevCompanyYTD: [],
};
